import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import type { QuickSelectOption } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/top/title-bar/update-jira/types';

export const getQuickSelectOption = (state: State): QuickSelectOption =>
	state.ui.Top.TitleBar.UpdateJira.quickSelectOption;
